import {
  GET_LIST_QUANLYTHUCHINGOAILE,
  GET_LIST_QUANLYTHUCHINGOAILE_SUCCESS,
  GET_LIST_QUANLYTHUCHINGOAILE_FAILURE,
  UPDATE_SEARCHTDATA_QUANLYTHUCHINGOAILE,
} from "./actionTypes";

export const getListQuanLyThuChiNgoaiLe = (dataSearch) => ({
  type: GET_LIST_QUANLYTHUCHINGOAILE,
  dataSearch,
});
export const getListQuanLyThuChiNgoaiLeSuccess = (data) => ({
  type: GET_LIST_QUANLYTHUCHINGOAILE_SUCCESS,
  payload: data,
});
export const getListQuanLyThuChiNgoaiLeFailure = (dataSearch) => ({
  type: GET_LIST_QUANLYTHUCHINGOAILE_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_QUANLYTHUCHINGOAILE,
  payload: data,
});
